'use client';

import { useNinetailed } from '@ninetailed/experience.js-react';
import { useSegmentTrack } from '../index';
import { ANALYTICS_EVENTS, LEAD_GENERATION_INTERACTION_TYPES } from '../types';
import type { LeadGenerationInteractionProps, TrackingFunction } from '../types';
import { validateLeadGenerationEventData } from '../validation';

export const useLeadGenerationInteraction = (
  props: LeadGenerationInteractionProps,
  autoTrack: boolean = false,
): TrackingFunction => {
  const ninetailed = useNinetailed();
  const trackSegment = useSegmentTrack(
    {
      eventName: ANALYTICS_EVENTS.LEAD_GENERATION_INTERACTION,
      properties: props,
      opts: {
        shouldSendToFacebook: props.interaction_type === LEAD_GENERATION_INTERACTION_TYPES.ENROLLMENT_CTA_TAPPED,
      },
    },
    autoTrack,
  );

  const track = (eventProperties: Record<string, unknown> = {}, callback?: () => void) => {
    validateLeadGenerationEventData({ ...props, ...eventProperties });
    ninetailed.track(props.interaction_type);
    trackSegment(eventProperties, callback);
  };

  return track;
};
